import type { RouteRecordRaw } from 'vue-router';
import md from '@/router/middlewares';
import store from '@/store';
import { TYPE_HTML } from '@/aquassist-shared/constants/types/features';

const coreRoutes: RouteRecordRaw[] = [
    // MAIN CLIENTS LIST
    {
        path: '/clients',
        name: 'clients',
        component: () => import('@/views/clients/ClientsList.vue'),
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },
    // SITES LIST
    {
        path: '/sites',
        name: 'sites',
        component: () => import('@/views/sites/SitesList.vue'),
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/GlobalDashboard.vue'),
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
        beforeEnter: (_to, _from, next) => {
            if (!store.getters.showGlobalDashboardByFeature) {
                next({ name: 'clients' });
            } else {
                next();
            }
        },
    },

    // AUTHENTICATION
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/LoginScreen.vue'),
        alias: '/',
    },
    {
        path: '/nat/acceptinvite',
        name: 'acceptInvite',
        meta: {
            middlewares: [md.dropTokens, md.decodeURLInviteData],
        },
        component: () => import('@/views/nat/AcceptInvite.vue'),
    },
    {
        path: '/nat/signup',
        name: 'signup',
        component: () => import('@/views/nat/SignupPage.vue'),
        meta: {
            middlewares: [md.dropTokens, md.decodeURLSignUpData],
        },
        props: (route) => ({
            data: route.query.url,
        }),
    },
    {
        path: '/nat/passwordreset',
        name: 'PasswordReset',
        component: () => import('@/views/nat/ResetPassword.vue'),
        meta: {
            middlewares: [md.dropTokens, md.decodeUrlResetPwdData],
        },
        props: (route) => ({
            code: route.query.url,
        }),
    },
    {
        path: '/teams',
        name: 'teams',
        meta: {
            middlewares: [md.auth],
        },
        component: () => import('@/views/SelectTeam.vue'),
    },
    {
        path: '/report/:htmlId',
        name: 'htmlReport',
        meta: {
            middlewares: [md.auth],
            featureFlag: TYPE_HTML,
        },
        component: () => import('@/views/reports/HtmlReportViewer.vue'),
        beforeEnter: async (_to, _from, next) => {
            if (!store.getters.showHtmlReportByFeature) {
                const teamId = store.getters.currentTeamId || window.$cookies?.get('currentTeamId');
                if (teamId) {
                    await store.dispatch('reloadTeam', teamId);
                }
            }
            if (!store.getters.showHtmlReportByFeature) {
                next({ name: 'clients' });
            } else {
                next();
            }
        },
    },
    {
        path: '/devices-documentation',
        name: 'devicesDocumentation',
        component: () => import('@/views/profile/DevicesDocumentation.vue'),
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },
    {
        path: '/videos',
        name: 'movies',
        component: () => import('@/views/movies/Movies.vue'),
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },

    // USER PROFILE
    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/profile/ProfilePage.vue'),
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },

    // NOTIFICATIONS
    {
        path: '/notifications',
        name: 'notifications',
        component: () => import('@/views/notifications/NotificationsList.vue'),
        meta: {
            middlewares: [md.auth, md.accessControl],
        },
    },

    // SANDBOX
    {
        path: '/shared-sandbox',
        name: 'shared-sandbox',
        component: () => import('@/views/sandbox/SharedSandbox.vue'),
        alias: '/shared-sandbox',
    },

    // PRIVACY POLICY
    {
        path: '/privacypolicy',
        name: 'privacyPolicy',
        component: () => import('@/views/PrivacyPolicy.vue'),
    },

    // 404 CATCH ALL
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: () => import('@/views/NotImplementedYet.vue'),
    },
];

export default coreRoutes;
